import api from "../services/apiCrypto";

export const getQuizLabel = (username: string, message: string): string => {
  return username !== "Declarante"
    ? `${username} ${message}`
    : `Você ${message}`;
};

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

export const isMobile = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const isExternalLink = (link: string): boolean => {
  return /http:\/\/|https:\/\//i.test(link);
};

export const errorMessage =
  "Algo inesperado aconteceu! Tente novamente mais tarde.";

export const reintegrateMessage =
  "Faça novamente a integração para buscar dados mais novos";

export const download = (link: string) => {
  const userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  if (chromeAgent && safariAgent) safariAgent = false;
  if (safariAgent) {
    window.location.href = link;
    return;
  } else {
    window.open(link);
  }
};

export const downloadPDF = (base64: string) => {
  const linkSource = `data:application/pdf;base64,${base64}`;
  const downloadLink = document.createElement("a");
  const fileName = `Relatório-${Date.now()}.pdf`;

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const getMuiInputCss = () =>
  document
    .querySelector("input.MuiInputBase-input")
    ?.classList.value.split(" ")
    .find((c) => c.includes("css")) ?? "";

export const getZeroBuyPrice = async (data: any) => {
  try {
    let hasZero = [];
    const custodias = await api.get("/mynt/custodia", {});
    const elementsNotRepeat: string[] = [];
  
    for (const element of data) {
      const code = element?.ativo;
      const isTaxa = (code.toLowerCase()).includes('taxa');
      if (isTaxa) continue;
      if (elementsNotRepeat.includes(code)) continue;
      else if (!element?.custoCompra) elementsNotRepeat.push(code);
      else continue;
      const custoCompra = element?.custoCompra;
  
      const reasonDictionary = [
        { text: "Preencha o custo de compra do ativo na aba", textLink: "Transferência de custódia", link: "/mynt/transferencia-custodia" }
      ];
      const hasCustodias: any[] = [];

      if (custodias && custodias?.data) {
        custodias && custodias?.data?.filter((custody: any) => {
            if (code === custody?.codigo && custody?.value == 0) {
              hasCustodias.push(custody);
              return;
            }
            else return;
        })
      }
      const reason = hasCustodias.length ? 0 : "";
      if ((custoCompra == 0 || !custoCompra)
        && (hasCustodias.length > 0 && hasCustodias[0]?.value == 0)) {
        hasZero.push({ code: code, reason: reason !== "" ? reasonDictionary[reason] : "" });
      }
      else if ((custoCompra == 0 || !custoCompra) && hasCustodias.length == 0) {
        hasZero.push({ code: code, reason: "" });
      }
    }
    return hasZero;
  } catch (error) {
    return [];
  }
}